<template>
    <div class="elFooter">
        <div class="footerTop">
            <div class="footerNav">
                <div class="footerLeft">
                    <div class="footerLeftFlex">
                        <div class="item">
                            <div class="name">企业服务</div>
                            <div class="contactUs">
                                <div class="li">松木ERP进销存管理系统</div>
                                <div class="li">木材仓储管理系统</div>
                                <div class="li">木材在线金融系统</div>
                                <div class="li">大数据管理系统</div>
                                <div class="li">硬木ERP进销存管理系统</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="name">金融服务</div>
                            <div class="financialService">
                                <div class="li">现货质押</div>
                                <div class="li">代赎货</div>
                                <div class="li">订单金融</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="name">数据服务</div>
                            <div class="contactUs">
                                <div class="li">德木云链</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="name">合同模板</div>
                            <div class="relatedProducts">
                                <div class="li">金融服务合同</div>
                                <div class="li">软件服务合同</div>
                                <div class="li">德木SAAS软件服务协议</div>
                                <div class="li">数据安全保密协议</div>
                                <div class="li">隐私政策</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="name">关于德木</div>
                            <div class="aboutUs">
                                <div class="li">德木介绍</div>
                                <div class="li">德木招聘</div>
                                <div class="li">联系我们</div>
                                <div class="li">在线客服</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footerRight">
                    <div class="item">
                        <img class="qrCode" src="../../public/images/official_account.jpg" alt="">
                        <p class="name">德木云小程序</p>
                    </div>
                    <div class="item">
                        <img class="qrCode" src="../../public/images/qrCode.jpg" alt="">
                        <p class="name">德木云公众号</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footerBottom">
            <div class="bottomComtent">
                <div class="left">
                    <span class="name">Copyright ©2021 </span>
                    <span class="name">江苏德木供应链管理有限公司 <a class="linkBeian" href="https://beian.miit.gov.cn/">版权所有 <img src="@/assets/police_badge.jpg" alt=""> 苏ICP备18028199号</a></span>
                </div>
                <div class="right">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            navList:[]
        }
    }
}
</script>

<style scoped>
    .footerTop{background: #3C3D3C;width: 100%;display: flex;align-items: center;justify-content: center;}
    .footerNav{display: flex;justify-content: center;width: 120rem;color: white;padding: 4rem 0;}
    .footerLeft{width: 70%;}
    .footerLeftFlex{display: flex;justify-content: space-between;}
    .footerLeftFlex .item{margin: 0 2rem;}
    .footerLeftFlex .item:first-child{margin-left: 0;}
    .footerLeftFlex .item:last-child{margin-right: 0;}
    .footerLeftFlex .item .name{font-size: 1.8rem;margin-bottom: 1rem;letter-spacing:0.3rem;text-align: left;}
    .footerLeftFlex .item .li{line-height: 2.6rem;text-align: left;font-size: 1.4rem;color: #bbb;font-size: 1.2rem;}
    .footerRight{width: 30%;display: flex;align-items:center;flex-direction: row;justify-content: flex-end;}
    .qrCode{width: 12rem;height: 12rem;margin-bottom: 1.5rem;}
    .footerRight .item{text-align: center;margin-left: 2rem;}
    .footerRight .name{letter-spacing:0.3rem;}
    .footerRight .qrCode{border-radius: 0.2rem;}

    .footerBottom{background: #2C2B2B;height: 6.8rem;width: 100%;display: flex;align-items: center;justify-content: center;}
    .bottomComtent{width: 120rem;display: flex;justify-content: space-between;}
    .bottomComtent .left{color: #fff;font-size: 1.4rem;display: flex;align-items: center;}
    .bottomComtent .right .icon{height: 4rem;border-radius: 0.2rem;}
    .linkBeian{margin-left: 10rem;color: #fff;}
</style>
